/**
 * @module TeamHeroSection
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { STRINGS } from '../helpers/strings';

/**
 * Represents the Hero section for Team page.
 *
 * @param {object} props - The component props object.
 * @param {Team} props.team - The team data object.
 * @returns {React.ReactElement} The TeamHeroSection component.
 */
export default function TeamHeroSection({ team }) {
  if (!team) {
    return null;
  }

  const { teamName, description } = team;

  return (
    <div
      className="team-hero text-white text-center"
      data-testid="lc-team-hero-section"
    >
      <div className="overlay py-bit_more_relaxed">
        <div className="container">
          <a className="back-button" href="/careers/teams/">
            <i className="icon icon-angle-left" />
            {STRINGS.teams.backToTeams}
          </a>
          <div className="content">
            <h2 className="mb-normal">{teamName}</h2>
            <p className="maxWidth-640 px-normal">{description}</p>
            {teamName === STRINGS.teams.internships ? (
              <a className="my-bit_more_relaxed" href="/careers/internships/">
                {STRINGS.general.aboutInternships}
                <i className="icon icon-angle-right" />
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
